export const addressComponentTypes = {
  city: 'locality',
  region: 'administrative_area_level_1',
  postal_code: 'postal_code',
  country: 'country',
  street_number: 'street_number',
  street_name: 'route',
};

export const remainingComponents = Object.values(addressComponentTypes);
